import IModel from "../model/applicationForm/IApplicationForm";
import IApplication from "../model/IApplication";
import Application from "../model/Application";
import BaseMapperV2 from "@/module/main/service/BaseMapperV2";
import CustomerMapperV3 from "@/module/main/service/CustomerMapperV3";
import IRequest from "../dto/financing-v3/IApplicationRequest";
import Request from "../dto/financing-v3/ApplicationRequest";
import IFinancedSubjectBase from "@/module/main/dto/IFinancedSubjectBase";
import FinancedSubjectType from "@/module/main/dto/FinancedSubjectTypeEnum";
import FinancedSubjectBase from "@/module/main/dto/FinancedSubjectBase";
import IOrderBase from "@/module/main/dto/IOrderBase";
import OrderBase from "@/module/main/dto/OrderBase";
import OrderType from "@/module/main/dto/OrderTypeEnum";
import IBrokeredOrder from "@/module/main/dto/IBrokeredOrder";
import BrokeredOrder from "@/module/main/dto/BrokeredOrder";
import IMerchantOrder from "@/module/main/dto/IMerchantOrder";
import MerchantOrder from "@/module/main/dto/MerchantOrder";
import IInstallmentSettings from "@/module/main/dto/IInstallmentSettings";
import InstallmentSettings from "@/module/main/dto/InstallmentSettings";
import IOrderFinancing from "@/module/main/dto/IOrderFinancing";
import OrderFinancing from "@/module/main/dto/OrderFinancing";
import OrderFinancingType from "@/module/main/dto/OrderFinancingTypeEnum";
import IOperatingLeaseSettings from "@/module/main/dto/IOperatingLeaseSettings";
import OperatingLeaseSettings from "@/module/main/dto/OperatingLeaseSettings";
import InstallmentScheduleParameter from "@/module/main/dto/InstallmentScheduleParameter";
import FinancingParameter from "@/module/main/dto/FinancingParameter";
import FinancingParameterType from "@/module/main/dto/FinancingParameterTypeEnum";
import IOperatingLeaseOrder from "@/module/main/dto/IOperatingLeaseOrder";
import OperatingLeaseOrder from "@/module/main/dto/OperatingLeaseOrder";
import DeliveryType from "@/module/main/dto/DeliveryTypeEnum";
import IOperatingLeaseItem from "@/module/main/dto/IOperatingLeaseItem";
import OperatingLeaseItem from "@/module/main/dto/OperatingLeaseItem";
import OperatingLeaseItemType from "@/module/main/dto/OperatingLeaseItemTypeEnum";
import CurrencyCode from "@/module/main/dto/CurrencyCodeEnum";
import GoodsType from "@/module/main/dto/GoodsTypeEnum";
import GoodsQuality from "@/module/main/dto/GoodsQualityEnum";
import ICarLoanOrder from "@/module/main/dto/ICarLoanOrder";
import {CarLoanOrder} from "@/module/main/dto/CarLoanOrder";
import isLargeCarLoan from "@/module/main/model/applicationForm/LargeCarLoan";
import IStandardOrder from "@/module/main/dto/IStandardOrder";
import StandardOrder from "@/module/main/dto/StandardOrder";
import IRequiredDocumentDetail from "@/module/main/dto/IRequiredDocumentDetail";
import {RequiredDocumentDetail} from "@/module/main/dto/RequiredDocumentDetail";
import {RequiredDocumentDetailCategory} from "@/module/main/dto/RequiredDocumentDetailCategory";
import RequiredDocumentDetailCategoryCode from "@/module/main/dto/RequiredDocumentDetailCategoryCodeEnum";
import RequiredDocumentDetailTypeCode from "@/module/main/dto/RequiredDocumentDetailTypeCodeEnum";
import {RequiredDocumentDetailType} from "@/module/main/dto/RequiredDocumentDetailType";
import ApiName from "@/module/api/service/ApiNameEnum";
import Culture from "@/module/main/page/CultureEnum";
import IWalletBase from "@/module/main/dto/financing-v3/IWalletBase";
import WalletBase from "@/module/main/dto/financing-v3/WalletBase";
import IOrderItem from "@/module/main/dto/financing-v3/IOrderItem";
import OrderItem from "@/module/main/dto/financing-v3/OrderItem";
import FileData from "@/module/main/dto/financing-v3/FileData";
import IFileData from "@/module/main/dto/financing-v3/IFileData";
import IOrderItemForm from "@/module/main/model/applicationForm/IOrderItem";
import Enum from "@/app/util/Enum";
import OrderItemTypeEnum from "@/module/main/dto/customer/OrderItemTypeEnum";
import PartnerWalletSettingsBase from "@/module/main/dto/financing-v3/PartnerWalletSettingsBase";
import PartnerWalletOrderBase from "@/module/main/dto/financing-v3/PartnerWalletOrderBase";
import WalletFinancingBase from "@/module/main/dto/financing-v3/WalletFinancingBase";
import WalletFinancingBaseType from "@/module/main/dto/financing-v3/WalletFinancingBaseTypeEnum";
import YesNo from "@/app/service/YesNoEnum";
import moment from "moment/moment";

class ApplicationV3Mapper extends BaseMapperV2
{
    readonly VERSION: string = 'v3';
    readonly API_NAME: string = ApiName.FINANCING;

    private readonly CZK_TO_EUR_RATE = 25;

    // Format: [num, base, earning, residual, earlyFee, wearFee]
    private readonly OPERATING_LEASE_PARAMETERS_DATA: [number, number, number, number, number | null, number][] = [
        [1, 568, 133, 21066, 4130, 4000],
        [2, 568, 133, 19413, 5086, 4000],
        [3, 568, 133, 17760, 6038, 4000],
        [4, 568, 133, 17348, 5751, 4000],
        [5, 568, 133, 16935, 5463, 4000],
        [6, 568, 133, 16522, 5176, 4000],
        [7, 568, 133, 16190, 4888, 4000],
        [8, 568, 133, 15696, 4601, 4000],
        [9, 568, 133, 15283, 4313, 4000],
        [10, 568, 133, 14871, 4025, 4000],
        [11, 568, 133, 14458, 3738, 4000],
        [12, 568, 133, 14045, 3450, 4000],
        [13, 568, 133, 13632, 3163, 4000],
        [14, 568, 133, 13219, 2875, 4000],
        [15, 568, 133, 12806, 2588, 4000],
        [16, 568, 133, 12394, 2300, 4000],
        [17, 568, 133, 11981, 2013, 4000],
        [18, 568, 133, 11568, 1725, 4000],
        [19, 568, 133, 11155, 1438, 4000],
        [20, 568, 133, 10742, 1150, 4000],
        [21, 568, 133, 10329, 863, 4000],
        [22, 568, 133, 9917, 764, 4000],
        [23, 568, 133, 9504, 288, 4000],
        [24, 568, 133, 9091, null, 4000],
        [25, 344, 61, 8747, null, 1000],
        [26, 344, 61, 8402, null, 1000],
        [27, 344, 61, 8058, null, 1000],
        [28, 344, 61, 7713, null, 1000],
        [29, 344, 61, 7369, null, 1000],
        [30, 344, 61, 7025, null, 1000],
        [31, 344, 61, 6680, null, 1000],
        [32, 344, 61, 6336, null, 1000],
        [33, 344, 61, 5992, null, 1000],
        [34, 344, 61, 5647, null, 1000],
        [35, 344, 61, 5303, null, 1000],
        [36, 344, 61, 4959, null, 1000],
        [37, 344, 61, 4800, null, 1000],
        [38, 344, 61, 4700, null, 1000],
        [39, 344, 61, 4600, null, 1000],
        [40, 344, 61, 4500, null, 1000],
        [41, 344, 61, 4400, null, 1000],
        [42, 344, 61, 4300, null, 1000],
        [43, 344, 61, 4200, null, 1000],
        [44, 344, 61, 4100, null, 1000],
        [45, 344, 61, 4000, null, 1000],
        [46, 344, 61, 3500, null, 1000],
        [47, 344, 61, 3000, null, 1000],
        [48, 344, 61, 2500, null, 1000],
    ];

    public toCreateRequest(application: IModel): IRequest
    {
        return new Request({
            financedSubject: this.getFinancedSubjectBase(application),
            originationContext: this.getOriginationContext(application.endpoints),
            customer: CustomerMapperV3.getCustomer(application)
        });
    }

    public fromResponse(response: any): IApplication
    {
        let {customerKey, state, stateReason, id, workflowSteps} = response;

        return new Application(customerKey, id, state, stateReason, workflowSteps);
    }

    public getFinancedSubjectBase(application: IModel): IFinancedSubjectBase
    {
        return new FinancedSubjectBase(
            application.loan.financedSubjectType,
            application.loan.financedSubjectType == FinancedSubjectType.CASH ? this.getCashBase(application) : undefined,
            application.loan.financedSubjectType == FinancedSubjectType.LIABILITY ? this.getLiabilityBase(application) : undefined,
            this.isOrder(application) ? this.getOrderBase(application) : undefined,
            this.isWallet(application) ? this.getWalletBase(application) : undefined,
        );
    }

    protected getFileData(data: IOrderItemForm): IFileData
    {
        return "" === data.imageFileName ?
            new FileData({filename: "iphone6s.jpg", url: "https://i.cdn.nrholding.net/32523771/2000/2000"}) :
            new FileData({filename: data.imageFileName, content: data.image});
    }

    protected getOrderItems(application: IModel): IOrderItem[]
    {
        let items: IOrderItem[] = [];
        for (let itemData of application.customer.orderItems)
        {
            let item = new OrderItem({
                code: itemData.code,
                image: this.getFileData(itemData),
                name: itemData.name,
                producer: itemData.producer,
                quantity: itemData.quantity,
                totalPrice: this.createAmount(itemData.totalPrice, application.currency.code),
                type: Enum.getEnumValue(OrderItemTypeEnum, itemData.type),
            });

            items.push(item);
        }

        return items;
    }

    protected getWalletBase(application: IModel): IWalletBase
    {
        let order: PartnerWalletOrderBase | undefined;

        if (application.loan.walletWithOrder === YesNo.YES)
        {
            order = new PartnerWalletOrderBase({
                amount: this.createAmount(application.loan.totalPrice, application.currency.code)!,
                items: this.getOrderItems(application),
                number: application.loan.orderNumber
            });
        }

        const partnerWallet: PartnerWalletSettingsBase = new PartnerWalletSettingsBase({
            order: order,
            walletUuid: application.customer.block1.walletUuid || undefined
        });

        const financing = new WalletFinancingBase({
            partnerWallet: partnerWallet,
            type: WalletFinancingBaseType.PARTNER_WALLET
        });

        return new WalletBase({financing: financing});
    }

    protected getOrderBase(application: IModel): IOrderBase
    {
        const isLease: boolean = application.loan.orderType === OrderType.OPERATING_LEASE;
        const isCarLoan: boolean = application.loan.orderType === OrderType.CAR_LOAN;
        const isBrokered: boolean = application.loan.orderType === OrderType.BROKERED;
        const isStandard: boolean = application.loan.orderType === OrderType.STANDARD;
        const isLargeCars: boolean = this.isLargeCarLoan(application);

        return new OrderBase({
            number: application.loan.orderNumber || undefined,
            preferredDownPayment: isLease || isLargeCars ? undefined : this.createAmount(application.loan.preferredDownPayment, application.currency.code),
            totalPrice: isLargeCars ? undefined : this.createAmount(application.loan.totalPrice, application.currency.code),
            type: application.loan.orderType,
            brokered: isBrokered ? this.getBrokeredOrder(application) : undefined,
            variableSymbol: application.loan.variableSymbol || undefined,
            specificSymbol: application.loan.specificSymbol || undefined,
            financings: this.getFinancings(application),
            operatingLease: isLease ? this.getOperatingLease(application) : undefined,
            carLoan: isCarLoan ? this.getCarLoan(application) : undefined,
            standard: isStandard ? this.getStandardOrder(application) : undefined,
        });
    }

    protected getStandardOrder(application: IModel): IStandardOrder
    {
        return new StandardOrder({
            items: this.getOrderItems(application) as [OrderItem],
        });
    }

    protected getBrokeredOrder(application: IModel): IBrokeredOrder
    {
        const broker = application.customer.broker;
        const items: IOrderItem[] = this.getOrderItems(application);

        const merchantOrder: IMerchantOrder = new MerchantOrder({
            totalPrice: this.createAmount(application.loan.totalPrice, application.currency.code),
            name: broker.merchantName || "",
            url: broker.merchantUrl || undefined,
            businessIdentificationNumber: broker.merchantBusinessId || undefined,
            number: broker.merchantNumber || undefined,
            reservationDate: broker.merchantReservationDate ? moment(broker.merchantReservationDate).format() : undefined,
            items: items.length > 0 ? items : undefined,
        });

        return new BrokeredOrder([merchantOrder]);
    }

    protected getFinancings(application: IModel): [IOrderFinancing]
    {
        const isLease: boolean = application.loan.orderType === OrderType.OPERATING_LEASE;
        const isCarLoan: boolean = application.loan.orderType === OrderType.CAR_LOAN;
        const isStandard: boolean = application.loan.orderType === OrderType.STANDARD;

        if (isLease)
        {
            return [new OrderFinancing({
                type: OrderFinancingType.OPERATING_LEASE,
                amount: this.createAmount("0", application.currency.code),
                operatingLease: this.getOperatingLeaseSettings(application),
            })];
        }

        if (isCarLoan)
        {
            return [new OrderFinancing({type: OrderFinancingType.CONSUMER_LOAN})];
        }

        const financingType: OrderFinancingType = isStandard
            ? Enum.getEnumValue(OrderFinancingType, application.loan.financingType) || OrderFinancingType.INSTALLMENT
            : OrderFinancingType.INSTALLMENT;

        const settings: IInstallmentSettings = new InstallmentSettings(
            this.createAmount(application.loan.preferredInstallment, application.currency.code),
            application.loan.productCode || undefined,
            application.loan.productSetCode || undefined,
        );

        return [new OrderFinancing({
            type: financingType,
            installment: financingType === OrderFinancingType.INSTALLMENT ? settings : undefined,
            consumerLoan: financingType === OrderFinancingType.CONSUMER_LOAN ? settings : undefined,
            goodsFinancing: financingType === OrderFinancingType.GOODS_FINANCING ? settings : undefined,
        })];
    }

    protected getOperatingLeaseSettings(application: IModel): IOperatingLeaseSettings
    {
        const parametersCount = this.getParametersCount(application.loan.productCode);
        const parameters = this.OPERATING_LEASE_PARAMETERS_DATA
            .slice(0, parametersCount)
            .map(([num, base, earning, residual, earlyFee, wearFee]) =>
                this.createInstallmentScheduleParameter(
                    application.currency.code,
                    num,
                    this.getCurrencyRelevantAmount(application.culture, base),
                    this.getCurrencyRelevantAmount(application.culture, earning),
                    this.getCurrencyRelevantAmount(application.culture, residual),
                    earlyFee !== null ? this.getCurrencyRelevantAmount(application.culture, earlyFee) : null,
                    this.getCurrencyRelevantAmount(application.culture, wearFee)
                )
            );

        return new OperatingLeaseSettings(application.loan.productCode, parameters);
    }

    private getParametersCount(productCode: string): number
    {
        const count = this.stringToNumber(productCode.substring(productCode.length - 2));
        return count === undefined || count === 1 ? 24 : count;
    }

    private createInstallmentScheduleParameter(currencyCode: CurrencyCode, numberOfInstallment: number, base: number,
        earning: number, residualValue: number, earlyRepaymentFee: number | null, excessiveWearFee: number)
    {
        let parameters = [];

        if (!!base)
            parameters.push(new FinancingParameter(FinancingParameterType.BASE, this.createAmount(base.toString(), currencyCode)!));

        if (!!earning)
            parameters.push(new FinancingParameter(FinancingParameterType.EARNING, this.createAmount(earning.toString(), currencyCode)!));

        if (!!residualValue)
            parameters.push(new FinancingParameter(FinancingParameterType.RESIDUAL_VALUE, this.createAmount(residualValue.toString(), currencyCode)!));

        if (!!earlyRepaymentFee)
            parameters.push(new FinancingParameter(FinancingParameterType.EARLY_REPAYMENT_FEE, this.createAmount(earlyRepaymentFee.toString(), currencyCode)!));

        if (!!excessiveWearFee)
            parameters.push(new FinancingParameter(FinancingParameterType.EXCESSIVE_WEAR_FEE, this.createAmount(excessiveWearFee.toString(), currencyCode)!));

        return new InstallmentScheduleParameter(numberOfInstallment, parameters);
    }

    protected getOperatingLease(application: IModel): IOperatingLeaseOrder
    {
        const items: IOperatingLeaseItem[] = [];
        const reservationDate: string = "2007-12-03T10:15:30+01:00";

        items.push(new OperatingLeaseItem({
            type: OperatingLeaseItemType.LEASED_GOODS,
            name: "iPhone 6s 32GB SpaceGray",
            code: "AIP6S32SG",
            image: new FileData({filename: "iphone6s.jpg", url: "https://i.cdn.nrholding.net/32523771/2000/2000"}),
            producer: "Apple",
            totalPriceWithoutVat: this.createAmount((this.getCurrencyRelevantAmount(application.culture, 22719)).toString(), application.currency.code),
            goodsType: GoodsType.MOBILE_PHONE,
            quality: GoodsQuality.NEW
        }));

        items.push(new OperatingLeaseItem({
            type: OperatingLeaseItemType.ACCESSORY,
            name: "Kryt FOXEDO",
            code: "FIXTCC-003",
            image: new FileData({
                filename: "krytiphone6s.jpg",
                url: "https://cdn.myshoptet.com/usr/www.kryteo.cz/user/shop/big/12543_tpu-gelovy-kryt-fixed-story-pro-apple-iphone-6-6s--ciry.jpg?5e827d35"
            }),
            totalPriceWithoutVat: this.createAmount((this.getCurrencyRelevantAmount(application.culture, 189)).toString(), application.currency.code),
        }));

        items.push(new OperatingLeaseItem({
            type: OperatingLeaseItemType.ACCESSORY,
            name: "Sklíčko Apple",
            code: "2KS-SKLO-CLEARO-6",
            image: new FileData({
                filename: "krytiphone6s.jpg",
                url: "https://cdn.myshoptet.com/usr/www.kryteo.cz/user/shop/big/25568-2_2-pack-tempered-glass-for-iphone-7.jpg?5ca65297"
            }),
            totalPriceWithoutVat: this.createAmount((this.getCurrencyRelevantAmount(application.culture, 149)).toString(), application.currency.code)
        }));

        return new OperatingLeaseOrder(this.isSk(application.culture) ? DeliveryType.DELIVERY_CARRIER : DeliveryType.ONLINE, items, reservationDate);
    }

    protected getCarLoan(application: IModel): ICarLoanOrder
    {
        if (this.isLargeCarLoan(application))
        {
            return new CarLoanOrder({
                calculationId: application.customer.carLoan.calculationId || undefined,
                dealerId: application.customer.carLoan.dealerId || undefined,
            });
        }

        let requiredDocuments: IRequiredDocumentDetail[] = [];

        if (application.customer.carLoan.proofOfIncome)
        {
            let requiredDocumentDetail = new RequiredDocumentDetail(new RequiredDocumentDetailCategory(RequiredDocumentDetailCategoryCode.PROOF_OF_INCOME, [
                new RequiredDocumentDetailType(RequiredDocumentDetailTypeCode.PROOF_OF_INCOME),
                new RequiredDocumentDetailType(RequiredDocumentDetailTypeCode.PAYSLIP),
                new RequiredDocumentDetailType(RequiredDocumentDetailTypeCode.LAST_MONTH_BANK_ACCOUNT_STATEMENT_SALARY_INCLUDED),
            ]));
            requiredDocuments.push(requiredDocumentDetail);
        }

        if (application.customer.carLoan.proofOfOtherIncome)
        {
            let requiredDocumentDetail = new RequiredDocumentDetail(new RequiredDocumentDetailCategory(RequiredDocumentDetailCategoryCode.PROOF_OF_OTHER_INCOME, [
                new RequiredDocumentDetailType(RequiredDocumentDetailTypeCode.PROOF_OF_INCOME),
            ]));
            requiredDocuments.push(requiredDocumentDetail);
        }

        return new CarLoanOrder({requiredDocuments});
    }

    private isLargeCarLoan(application: IModel): boolean
    {
        return isLargeCarLoan(application.loan.financedSubjectType, application.loan.orderType, application.loan.carLoanType);
    }

    private getCurrencyRelevantAmount(culture: Culture, amount: number): number
    {
        const divideBy = this.isSk(culture) ? this.CZK_TO_EUR_RATE : 1;
        return amount / divideBy;
    }
}

export default new ApplicationV3Mapper();
